import { Vue, Component, Emit } from "vue-property-decorator";
import { getUserExportPdf } from "@/api/aijiaoaiCourse";
import { Base64 } from "@/libs/tools";
@Component
export default class ExpReport extends Vue {
    @Emit()
    exitExpReport() {
        return "close";
    }
    private nickName: string = "";
    private courseId: number = null;

    mounted() {
        this.nickName = JSON.parse(localStorage.getItem("user")).nickname;
        this.nickName = Base64.decode(this.nickName);
        this.courseId = Number(this.$route.params.courseId);
    }
    lookReport() {
        this.$router.push({
            path: "/CourseReport/" + this.courseId
        });
    }
}
//@ts-ignore
export { default as ExpReport } from "./index.vue";
